import { WebhookAuthCredDto } from './ihub-devices';
import { DeviceType, IntegrationFullDto, IntegrationLimitedDto } from './integrationTypes';

export enum ExternalConnectionType {
  Vms = DeviceType.Vms,
  ExternalService = DeviceType.ExternalService,
}

export const connectionTypeName = {
  [ExternalConnectionType.Vms]: "VMS",
  [ExternalConnectionType.ExternalService]: "External Service",
};

export type ConnectedDeviceFilterChoice = Record<string, string>;

export interface ConnectedDeviceFilter {
  key: string;
  displayName: string;
  required: boolean;
  allowFreeText?: boolean;
}

export interface ExternalConnectionLimitedDto {
  id?: string;
  tenantId: string;
  authUserId: string;
  type: ExternalConnectionType;
  name: string;
  description: string;
  integrationId: string;
  integration?: IntegrationLimitedDto;
  lastScanTime: string;
  created: string;
  updated: string;
  availableDeviceCount: string;
}

export interface ExternalConnectionDto extends ExternalConnectionLimitedDto {
  integrationFields: { [key: string]: string | boolean | number };
  deviceCreationKeyValues: ConnectedDeviceFilter[];
  deviceCreationChoices: ConnectedDeviceFilterChoice[];
  integration: IntegrationFullDto;
  smtpUsername: string;
  smtpPassword: string;
  webhookAuthCredDto: WebhookAuthCredDto;
}
